'use strict';

module.exports = function (ngModule) {
    ngModule.controller('stealthDeployConfigController', require('./stealth_deploy_config'));

    ngModule.controller('stealthOpViewController', require('./stealth_op_view'));

    ngModule.controller('stealthConnController', require('./stealth_conn'));
    ngModule.controller('stealthConnOrigController', require('./stealth_conn_orig'));

    ngModule.controller('stealthEventsController', require('./stealth_events'));
    ngModule.controller('stealthEventsOrigController', require('./stealth_events_orig'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/stealth/index.js
 **/